import type { CultureCode } from '../types/agency.interfaces';
import type { AgencyMarket } from '../types/agency-market.types';
import { normalizeAgencyMarket } from '../types/agency-market.types';

const DEFAULT_COSTA_CLICK_CULTURE: CultureCode = 'it-IT';

const COSTA_CLICK_CULTURES = [
  'de-AT',
  'de-DE',
  'en-BZ',
  'en-GB',
  'en-PH',
  'en-US',
  'es-AR',
  'es-ES',
  'fr-BE',
  'fr-FR',
  'it-CH',
  'it-IT',
  'nl-BE',
  'pt-BR',
  'pt-PT',
  'es-MX',
] as const satisfies readonly CultureCode[];

const COSTA_CLICK_CULTURE_BY_AGENCY_MARKET: Record<AgencyMarket, CultureCode> = {
  I: 'it-IT',
  A: 'de-AT',
  B: 'fr-BE',
  D: 'de-DE',
  GB: 'en-GB',
  E: 'es-ES',
  RA: 'es-AR',
  FI: 'en-BZ',
  F: 'fr-FR',
  P: 'pt-PT',
  USA: 'en-US',
  BR: 'pt-BR',
  CH: 'it-CH',
  PL: 'en-BZ',
  CZ: 'en-BZ',
  SK: 'en-BZ',
  HR: 'en-BZ',
  MED: 'en-BZ',
  EU: 'en-BZ',
  OL: 'es-MX',
  NL: 'nl-BE',
  CIS: 'en-BZ',
  HK: 'en-PH',
  JP: 'en-PH',
  AU: 'en-PH',
};

function isCultureCode(culture: string | null | undefined): culture is CultureCode {
  if (!culture) return false;

  return COSTA_CLICK_CULTURES.includes(culture.trim() as CultureCode);
}

export function resolveCostaClickCultureCode(
  agencyMarket: string | null | undefined,
  agencyLanguage: string | null | undefined,
  backendCulture: string | null | undefined,
): CultureCode {
  const market = normalizeAgencyMarket(agencyMarket);
  const normalizedLanguage = agencyLanguage?.trim().toUpperCase();

  if (market) {
    // Reserved for future market/language-specific rules, matching Marketing Box.
    void normalizedLanguage;
    return COSTA_CLICK_CULTURE_BY_AGENCY_MARKET[market];
  }

  if (isCultureCode(backendCulture)) {
    return backendCulture.trim() as CultureCode;
  }

  return DEFAULT_COSTA_CLICK_CULTURE;
}
